export const BRAINTREE = 'braintree';
export const BRAINTREE_PAYPAL = 'braintreepaypal';
export const BRAINTREE_PAYPAL_CREDIT = 'braintreepaypalcredit';
export const BRAINTREE_VISACHECKOUT = 'braintreevisacheckout';
export const BRAINTREE_LOCAL_METHODS = 'braintreelocalmethods';
export const BRAINTREE_GOOGLEPAY = 'googlepaybraintree';
export const BRAINTREE_ACH = 'braintreeach';
export const BRAINTREE_ACCELERATED_CHECKOUT = 'braintreeacceleratedcheckout';

export const PAYPAL_COMMERCE = 'paypalcommerce';
export const PAYPAL_COMMERCE_ACCELERATED_CHECKOUT = 'paypalcommerceacceleratedcheckout';
export const PAYPAL_COMMERCE_ALTERNATIVE_METHODS = 'paypalcommercealternativemethods';
export const PAYPAL_COMMERCE_CREDIT = 'paypalcommercecredit';
export const PAYPAL_COMMERCE_CREDIT_CARDS = 'paypalcommercecreditcards';
export const PAYPAL_COMMERCE_VENMO = 'paypalcommercevenmo';
